import { NavLink as ReactRouterNavLink } from 'react-router-dom'
import { NavLink } from '@mantine/core'

import classes from '@/components/InlineLink/InlineLink.module.css'
import type { InlineLinkProps } from '@/components/InlineLink/InlineLink.types'

export function InlineLink({
  label,
  state,
  target,
  ...props
}: InlineLinkProps) {
  return (
    <NavLink
      {...props}
      className={classes.link}
      component={ReactRouterNavLink}
      label={label}
      state={state}
      to={target}
    />
  )
}
